/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getFinanceOrderListByCreatedUserId,
    setFinanceMarketCost,
    getFinanceMarketCostDetailTemplate,
    importFinanceMarketCostDetail, setPayeeInfo,
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'
import {  payInfoList, getBranchList } from '@/api/common'
import * as math from 'mathjs'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {getAgeByCardId} from "@/utils/checkIDCard";
import CommonData from "@/utils/commonData";


// 金额的校验
const checkAge = (rule, value, callback) => {
    if (value) {
        const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if (!reg.test(value)) {
            callback(new Error('请输入数字值'))
        } else {
            // if (value > 2000) {
            //     callback(new Error("请输入不超过2000的数！"))
            // } else {
                callback()
            // }
        }
    }else{
        callback(new Error("金额不可为空！"))
    }
}

@Component({
    components:{
        MoreUsersFilter
    }
})


export default class MarketCostAdd extends Vue {
    logList = []
    tableRandom = Math.random()
    tableKey = Math.random()
    tableData = []
    select = '0'  //
    formData = {
        types: '',// 费用类型
        other: '',// 费用类型 --- 输入框
        // financeOrderId: '', // id
        // financeOrderCode: '',// 编号
        // price: '',
        // score: '',
        reason: '', //申请原因
        directorUserId: UserModule.userId || '',
        reward: '0',  // 奖励形式- 实物
        directorUserName :''
    }
    fileList = []
    fileList1 = []
    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    feeTypeList = [
        {label: '合作顾问额外奖励', value: '0'},
        {label: '中小顾问积分奖励', value: '1'},
        {label: '学生奖学金申请', value: '2'},
        {label: '市场活动费用', value: '3'},
        {label: '其他', value: '4'}
    ] // 费用类型
    operationShow = true
    backMoneyStatus = ''
    showInput: any = true
    // numberlimit = [{required: true, validator: checkAge, trigger: ['change', 'blur']}]
    formRules = {
        types: [{required: true, message: '请选择费用类型', trigger: ['change', 'blur']}],
        financeOrderCode: [{required: true, message: '请选择订单', trigger: ['change', 'blur']}],
        reason: [{ required: true, message: '请输入申请原因', trigger: 'blur' }],
        // price: [{required: true, validator: checkAge, trigger: ['change', 'blur']}],
    }
    rewardList = [
        {label: '实物', value: '0'},
        {label: '非实物', value: '1'},
    ]
    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    // orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelect = {
        id: null, //订单id
        code: '', //订单code
        price: '', //订单金额
    }
    currentPage = 1
    pagesize = 20
    customerName = ''
    sourceName = ''
    orderDialogSelectTable = [] //选中数据
    tableDataOrder = [] //明细列表
    file = []
    fileData = null
    readyOption = true
    newAccountDialog = false

    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号
    searchBranchName: any = null //开户网点
    branchInfoList = [] // 开户网点数据
    branchPage = 1
    branchLimit = 20
    formRule = {
        types: [{required: true, message: '请选择退款类型', trigger: ['blur','change']}],
        refundDate: [{ required: true, message: '请选择期待退款时间', trigger: 'change' }],
        refundCause: [{ required: true, message: '请输入退款原因', trigger: 'blur' }],
        refundPrice: [{ required: true, message: '请输入本次退款金额', trigger: 'blur' }],
        main: [{required: true, message: '请选择退款主体', trigger: 'change'}],
        // account: [{required: true, message: `请输入${this.formData.main === '1' ? '合作伙伴' : '学生'}退款账户`, trigger: 'blur'}],
        // mainPartName: [{required: true, message: `请选择${this.formData.main === '1' ? '合作伙伴' : '学生'}名称`, trigger: ['blur','change']}],
        name: [{ required: true, message: '请选择开户名称', trigger: 'change' }],
        cardNum: [{ required: true, message: '请选择银行卡号', trigger: 'change' }],
        phoneNo: [{ required: true, message: '请填写电话号码', trigger: ['change','blur' ]}],
        certificateNo: [{ required: true, message: '请填写身份证号', trigger: ['change','blur' ]}],
        selectedDetailArea: [{ required: true, message: '请填写详细地址信息', trigger: ['change', 'blur'] }],
        selectedArea: [{ required: true, message: '请填写常住地址信息', trigger: ['change', 'blur'] }],
    }
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
        selectedArea: [],
        selectedDetailArea: null
    }
    // accountEditBtn = false
    payeeInfoList = [] // 开户名称数据
    payInfoLoading = false
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    type = '' //账户类型
    name = '' //开户名称
    cardNum = '' //银行卡号
    branch = '' //开户网点
    phoneNo = '' //手机号
    certificateNo = '' // 身份证号
    syncDialogVisible = false
    msg = ''
    certificateNoDisabled = true
    phoneNoDisabled = true
    loading = false
    options = CommonData.regionData
    selectedOptions = []
    get userName() {
        return UserModule.userName
    }

    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableDataOrder.forEach(item => {
                num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.priceOrScore))))
            }
        )
        return num
    }

    get orderAllScore() {
        let num = 0
        this.tableDataOrder.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.price))))
        });
        num = math.multiply(math.bignumber(num), 0.01) as any
        return num
    }

    menuBtn = menuBtn
    formatDate = formatDate

    // 选择订单列表
    choiceOrder(e) {
        this.orderDialog = true
        this.currentPage = 1
        this.getFinanceOrderListByCreatedUserId()
        e.target.blur()
    }
    clickAddOrder() {
        if(!this.formData.types) {
            this.$message.error('请选择费用类型')
            return
        }
        this.select = '0'
        this.currentPage = 1
        this.orderDialogInputValue = ''
        this.customerName = ''
        this.sourceName = ''
        this.orderDialog =  true
        this.getFinanceOrderListByCreatedUserId()
        this.defaultChecked()
    }
    defaultChecked(){
        this.$nextTick(() => {
            let order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableDataOrder.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }
    // 订单列表确认
    orderDialogConfirm() {
        this.tableDataOrder = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableDataOrder.findIndex((items) => {return items.id === item.id})
            if(Index == -1){
                if(this.formData.types == '1'){
                    item.priceOrScore = Number(item.price) * 0.01
                }
                this.tableDataOrder.push({
                    ...item,
                    priceOrScore: item.priceOrScore ? item.priceOrScore : 0,
                })
            }

        })
        this.orderDialog = false
        this.orderDialogInputValue = ''
    }
    // 订单列表取消
    handleOrderDialog(){
        this.orderDialogSelectTable.map(item => {
            this.tableDataOrder.map(items => {
                if(item.id !== items.id){
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if(this.tableData.length > 0){
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row,true)
            });
        }else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }
    clickOrderDialogTableRow(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
        // if(!(row.isSelect == '1')) return
        // (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }
    thisBackMoneyChange(row, val){
        val = this.handleOninput(val,'2')
        this.tableDataOrder.forEach((item,index) => {
            if(item.id === row.id){
                item.priceOrScore = val
            }
        })
    }
    // // 订单列表确定事件
    // orderDialogConfirm() {
    //     this.formData.financeOrderId = this.orderDialogSelect.id
    //     this.formData.financeOrderCode = this.orderDialogSelect.code
    //     if (this.formData.types == '1') {
    //         (this.formData.score as any) = String((this.orderDialogSelect.price as any) * 0.01)
    //     }

    //     this.orderDialog = false
    //     this.orderDialogInputValue = ''
    // }
    getRowKeys(row) {
        return `${row.id}`
    }
    // 明细删除
    clickDelOrder(row) {
        // this.tableDataOrder = this.tableDataOrder.filter(item => item.id !== row.id)
        // this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.id !== row.id)
        // this.tableDataOrder.forEach(row => {
        //     (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row, true)
        // })

        this.tableDataOrder = this.tableDataOrder.filter((item =>
                item.id !== row.id  // 中小顾问积分奖励 id =  // 学生奖学金申请 id=  // 市场活动费用 id=  // 其他 id // 合作顾问奖励
        ))
    }

    // 新建保存并提交
    clickSubmintButton() {
        let financeMarketCostDetailList = []
        financeMarketCostDetailList = this.tableDataOrder.map(item => ({ financeOrderId: item.id, priceOrScore: String(item.priceOrScore) }))

        /* * 判断数组的每一项是否都不为空*/
        const isAllZero = financeMarketCostDetailList.every(item => (item.priceOrScore !== 'undefined' && item.priceOrScore !== ''));
        if (!isAllZero) {
            this.$message.error('有未填写本次费用金额的订单，请去填写')
            return;
        }
        const obj = {
            types: this.formData.types, // 费用类型
            other: this.formData.other,
            reason: this.formData.reason, //申请原因4
            financeMarketCostDetailList: financeMarketCostDetailList,
            directorUserId: this.formData.directorUserId,
            reward: this.formData.reward,
            payeeInfoId: this.payInfo.id ? this.payInfo.id : this.payInfo.payeeInfoId ? this.payInfo.payeeInfoId : '', //易快报收款账户id
            certificateNo : this.payInfo.certificateNo,
            phoneNo : this.payInfo.phoneNo,
            provinces: null,
            city: null,
            districts: null,
            others: null
        };
       
        if(this.payInfo.selectedArea && this.payInfo.selectedArea.length) {
            obj.provinces = this.payInfo.selectedArea[0]
            obj.city = this.payInfo.selectedArea[1]
            obj.districts = this.payInfo.selectedArea[2]
            obj.others = this.payInfo.selectedDetailArea?this.payInfo.selectedDetailArea:null
          }
        (this.$refs['formRef'] as HTMLFormElement).validate((valid1: boolean) => {
            if (valid1) {
                if (this.formData.types == '4' && !this.formData.other) {
                    this.$message.error('其他不可为空！')
                    return
                }
                if (financeMarketCostDetailList.length === 0) {
                    this.$message.error('请添加订单为市场费用添加明细')
                    return
                }
                // if (this.formData.types != '1' && !this.formData.price) {
                //     this.$message.error('金额不可为空！')
                //     return
                // }
                // if (this.formData.types == '1' && !this.formData.score) {
                //     this.$message.error('积分不可为空！')
                //     return
                // }

                /*如果是个人账户 身份证号码校验是否符合规则*/
                let flag = true
                if (this.payInfo.type === '个人账户') {
                    if (!getAgeByCardId(this.payInfo.certificateNo)) {
                        flag = false
                        return
                    }
                    /*如果是个人账户，正则校验手机号格式是否正确*/
                    if (this.payInfo.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.payInfo.phoneNo))) {
                        this.$message.error('请输入正确的手机号');
                        flag = false
                    }
                }
                if (!flag) {
                    return;
                }
                // if (this.formData.reward == '1' && this.payInfo.type === '个人账户' && (this.payInfo.selectedArea.length < 1 || !this.payInfo.selectedDetailArea)) {
                //     this.$message.error('请输入常住地址信息！')
                //     return;
                // }
                this.disabledButton = true
                this.loading = true
                setFinanceMarketCost(delNullProperty(obj)).then(() => {
                    this.$message.success('新建成功')
                    this.loading = false
                    setTimeout(() => {
                        this.closePage()
                        this.$router.go(-1)
                    }, 1500)
                    this.saveDraftDialogShow = false

                }).catch((err: Error) => {
                    if (err) {
                        this.disabledButton = false
                        this.loading=  false
                    }
                    if (err.message === '审批流报错') {
                        this.errorDialogShow = true
                    }
                })
            }
        })

    }
    closePage() {
        window.close()
    }
    changeTypes(val) {
        if(val == '1'){
            this.tableDataOrder.forEach((item,index) => {
                item.priceOrScore = Number(item.price) / 100
            })
        }
        // this.formData.score = ''
        // this.formData.price = ''
        // this.formData.financeOrderId = ''
        // this.formData.financeOrderCode = ''
        this.formData.reward = '0'
        this.tableDataOrder = []
    }
    // 订单列表搜索
    async clickorderDialogFilter() {
        if(this.select == '1'){ //具体来源
            this.sourceName = this.orderDialogInputValue
            this.customerName = ''
        }else if(this.select == '0'){ //客户名称
            this.customerName = this.orderDialogInputValue
            this.sourceName = ''
        }
        this.currentPage = 1
        this.getFinanceOrderListByCreatedUserId()
    }
    handleOrderFilter(val){
        this.select = val
        this.orderDialogInputValue = ''
    }
    // 费用金额正则
    handleOninput(num,limit) {
        var str = num
        var len1 = str.substr(0, 1)
        var len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            var str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        if (limit / 1 === 1) {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/,'$1') // 小数点后只能输 1 位
        } else {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1') // 小数点后只能输 2 位
        }
        return str
    }
    onExchangeChange(index){
        let tmpObj = this.tableDataOrder[index];
        this.$set(this.tableDataOrder, index, tmpObj);
    }
    // 费用金额
    thisMoneyChange(row, val) {
        val = this.handleOninput(val,'2')
        this.tableDataOrder.forEach((item,index) => {
            if(item.id === row.id){
                const tmpObj = this.tableDataOrder[index];
                this.$set(this.tableDataOrder, index, tmpObj);
            }
        })
    }

    handleorderRowClick(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }
    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
        if(this.tableDataOrder.length > 0){
            this.tableDataOrder.map(item => {
                this.orderDialogSelectTable.map(items => {
                    if(item.id == items.id) {
                        items.priceOrScore = item.priceOrScore
                    }
                })
            })
        }
    }

    // 订单列表change
    // orderDialogSelectionChange(selectionArr: any[]) {
    //     if (selectionArr.length > 0) {
    //         this.orderDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
    //         if (selectionArr.length > 1) {
    //             const orderTableToggle = this.$refs.orderDialogTable as HTMLFormElement
    //             orderTableToggle.clearSelection()
    //             orderTableToggle.toggleRowSelection(selectionArr.pop())
    //         }

    //     } else {
    //         for (const key in this.orderDialogSelect) {
    //             this.orderDialogSelect[key] = null
    //         }
    //     }
    // }

    // 选过的订单不可选
    orderTableSelect(row) {
        return row.isSelect == '1'
    }

    // 订单列表
    async getFinanceOrderListByCreatedUserId() {
        this.orderDialogTableLoading = true
        const obj = {
            customerName: this.customerName,
            page: this.currentPage,
            limit: this.pagesize,
            source: this.sourceName,
            types: this.formData.types,
        }
        await getFinanceOrderListByCreatedUserId(delNullProperty(obj)).then((data: any) => {
            this.orderDialogTaleData = data.financeOrderList
            this.orderDialogTotal = data.allNum
            this.orderDialogTableLoading = false
            // this.orderDialogInputValue = ''
            // this.tableRandom = Math.random();
            this.orderDialogTableLoading = false
        }).catch((err: Error) => {
            this.orderDialogTableLoading = false
        })
    }

    handleSizeChange(val) {
        this.pagesize = val
        this.getFinanceOrderListByCreatedUserId();
    }

    handleCurrentChange(val) {
        this.currentPage = val
        this.getFinanceOrderListByCreatedUserId();
    }
    // 下载导入回款模板
    async clickDownload(){
        const data: any = await getFinanceMarketCostDetailTemplate()
        const a: any = document.createElement('a')
        a.href = data.financeMarketCostDetailTemplateUrl //  URL对象
        a.click() // 模拟点击
    }
    // 导入
    handleFileChange(file,fileList) {
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.file = fileList.slice(-1);
        if(this.file.length > 0){
            this.sureExport()
        }
    }
    async sureExport() {
        this.loading = true
        const formData = new FormData()
        formData.append('file', this.file[0].raw)
        importFinanceMarketCostDetail(formData).then((res) => {
            const { financeOrderList } = res as unknown as { financeOrderList: any;}

            // 如果是 中小顾问积分奖励 默认赋值为订单的100%
            financeOrderList.map(item => {
                this.tableDataOrder.push({
                    ...item,
                    financeBackMoneySum: item.financeBackMoneySum ? item.financeBackMoneySum : item.financeBackMoneyPrice, //回款金额
                    //     积分
                    priceOrScore: this.formData.types == '1' ? (Number(item.price) * 0.01) : item.priceOrScore
                })
            })
            this.loading = false
            this.file = []
            this.fileData = {}
        }).catch(err => {
            console.log(err)
            this.loading = false
        })
    }
    handleFile(){
        if (this.formData.types) {
            this.readyOption = false
        }else {
            this.$message.error('请选择费用类型')
        }
    }


    /*
    * 2023-4-20 新增*/
    // 新增账户打开弹窗
    clickNewAccount(){
        this.newAccountDialog = true
        this.getBranchList(); //开户网点
    }

    // 开户网点
    async getBranchList() {
        let objs = {
            name: this.searchBranchName,
            page: this.branchPage,
            limit: this.branchLimit,
        }
        const data: any = await getBranchList(delNullProperty(objs))
        this.branchInfoList = [...this.branchInfoList, ...data.branchList]
        let result = []
        let obj = {}
        for(let i =0; i<this.branchInfoList.length; i++){
            if(!obj[this.branchInfoList[i].name]){
                result.push(this.branchInfoList[i]);
                obj[this.branchInfoList[i].name] = true;
            }
        }
        this.branchInfoList = result
    }

    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            if (this.searchCardName && this.payInfo.cardNum) {
                this.searchName = this.payInfo.name
                this.payeeInfoList = []
                this.payInfo.page = 1
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
    }

    async handleRemotePayInfo (query: any) {
        this.searchName = query.trim();
        this.payInfo.page = 1
        this.payInfo.limit = 20
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
            this.payeeInfoList = []
            this.payInfoList();
        }
    }
    // 开户名称列表
    async payInfoList() {
        let objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        let result = []
        let obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }

    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }

    handleClearPayInfo() {
        this.searchName = null
        this.searchCardName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.payeeInfoId = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        this.payInfoList()
    }

    // 开户名称
    handlePayInfoChange (indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        const obj = this.payeeInfoList.find((item,index)=> item.id === indexId);
        this.$set(this.payInfo,'name',obj.name)
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.type = obj.type
        this.payInfo.payeeInfoId = obj.id;
        this.$set(this.payInfo,'phoneNo',obj.phoneNo)
        this.$set(this.payInfo,'certificateNo',obj.certificateNo)
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
        if (!obj.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!obj.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
    }

    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            if (this.searchName && this.payInfo.name) {
                this.searchCardName = this.payInfo.cardNum
                this.payInfo.page = 1
                this.payeeInfoList = []
            } else {
                this.payeeInfoList = []
                this.payInfo.page = 1
            }
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
    }

    async handleRemotePayCard(query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: query})
            this.payeeInfoList = result.payeeInfoList
        } else {
            this.payeeInfoList = []
            this.payInfoList();
        }
    }


    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }

    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.searchName = null
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.payeeInfoId = ''
        /*
       * 如果是个人账户清空*/
        this.payInfo.certificateNo = ''
        this.payInfo.phoneNo = ''
        this.payInfoList()
    }


// 银行卡号
    handlePayChangeCard(indexVal) {
        this.msg = indexVal.message
        if(indexVal.message){
            this.syncDialogVisible = true
        }
        const indexId = indexVal.id
        let obj = this.payeeInfoList.find((item, index) => item.id === indexId)
        this.$set(this.payInfo,'name',obj.name)
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        this.payInfo.type = obj.type
        this.$set(this.payInfo,'phoneNo',obj.phoneNo)
        this.$set(this.payInfo,'certificateNo',obj.certificateNo)
        if (!obj.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!obj.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }

    closeSyncDialog(){
        this.syncDialogVisible = false
    }

    async handleBranchInfo(){
        if((this.branchInfoList.length == 0 || !this.searchBranchName) && !this.branch){
            this.searchBranchName = null
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.searchBranchName })
            this.branchInfoList = result.branchList
        }
        if(this.branch){
            this.branchInfoList = []
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.branch })
            this.branchInfoList = result.branchList
        }
    }
    async handleRemoteBranch (query: any) {
        this.searchBranchName = query.trim();
        this.branchPage = 1
        this.branchLimit = 20
        if (query !== '') {
            const result: any = await getBranchList({page: this.branchPage,  name: query })
            this.branchInfoList = result.branchList
        } else {
            this.branchInfoList = []
            this.getBranchList();
        }
    }

    handleBranchLoadmore() {
        this.branchPage ++
        this.getBranchList();
    }
    handleClearBranch() {
        this.searchBranchName = null
        this.branch = ''
        this.branchPage = 1
        this.getBranchList()
    }

    handleBranchChange (val) {
        this.branch = val
    }

    changeType(val){
        this.certificateNo = ''
        this.phoneNo = ''
    }
    doCancel(){
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.newAccountDialog = false
    }
    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        if((this.type === 'PERSONAL'&&this.certificateNo=='')|| (this.type === 'PERSONAL'&&this.phoneNo=='')){
            this.$message.error(`请将${this.certificateNo === '' ? '身份证号，' : ''}${this.phoneNo === '' ? '手机号，' : ''}填写完整`)
            return
        }
        let flag = true
        // 如果是个人账户
        if (this.type == '1' || this.type == 'PERSONAL') {
            /*身份证号码校验是否符合规则*/
            if (!getAgeByCardId(this.certificateNo)) {
                flag = false
                return
            }
            /*如果是个人账户，正则校验手机号格式是否正确*/
            if (this.phoneNo && !(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNo))) {
                this.$message.error('请输入正确的手机号');
                flag = false
            }
        }

        if (!flag) {
            return
        }

        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
            certificateNo: this.certificateNo,
            phoneNo: this.phoneNo,
        }
        const { payeeInfoId } = await setPayeeInfo(delNullProperty(obj)) as unknown as { payeeInfoId: string}
        this.payInfo.id = payeeInfoId
        this.$set(this.payInfo,'name',this.name)
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.$set(this.payInfo,'phoneNo',this.phoneNo)
        this.$set(this.payInfo,'certificateNo',this.certificateNo)
        if (!this.certificateNo) {
            this.certificateNoDisabled = false
        } else {
            this.certificateNoDisabled = true
        }
        if (!this.phoneNo) {
            this.phoneNoDisabled = false
        } else {
            this.phoneNoDisabled = true
        }
        this.payInfo.type = this.type && this.type == 'PUBLIC' ? '对公账户' : this.type && this.type == 'PERSONAL' ? '个人账户': ''
        this.newAccountDialog = false

        //     清空上一次填写的数据
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.$set(this.payInfo, 'selectedArea', [])
        this.$set(this.payInfo, 'selectedDetailArea', '')
        this.selectedOptions = []
    }

    changeDirectorUserId(e){
        this.formData.directorUserId = e.id
    }
    handleChange(value) {
        // 如果需要获取中文名称，可以通过以下方式
        const province = this.findLabelByValue(this.options, value[0])
        const city = this.findLabelByValue(province.children, value[1])
        const district = this.findLabelByValue(city.children, value[2])
        this.payInfo.selectedArea = [province.label,city.label,district.label]
      }
      getSelectedLabels() {
        if (this.payInfo.selectedArea.length !==3) return []
        const province = this.options.find(item => item.label === this.payInfo.selectedArea[0])
        // 兼容小程序地址
        let city = null
        if(this.payInfo.selectedArea[1]===this.payInfo.selectedArea[0]) {
             city = province.children.find(item => item.label === '市辖区')
        } else {
             city = province.children.find(item => item.label === this.payInfo.selectedArea[1])
        }
        const district = city.children.find(item => item.label === this.payInfo.selectedArea[2])
        this.selectedOptions = [province.value, city.value, district.value]
      }
      // 根据value查找对应的label
      findLabelByValue(arr, value) {
        return arr.find(item => item.value === value)
      }
    @Watch("directorUserId", { deep: true })
    handle(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }

    @Watch("userName", { deep: true })
    handleUserName(userName: string) {
        if(!this.formData.directorUserName){
            this.formData.directorUserName = userName
        }
    }
}
